import { useRuntimeConfig } from '#imports'

import { useIsE2ETestingEnvironment } from '@backmarket/nuxt-module-qa/useIsE2ETestingEnvironment'

export function useFetchFallbackOnError() {
  const { FF_CMS_PAGE_FETCH_FALLBACK_ON_ERROR } = useRuntimeConfig().public
  const isE2ETestingEnvironment = useIsE2ETestingEnvironment()

  return FF_CMS_PAGE_FETCH_FALLBACK_ON_ERROR || isE2ETestingEnvironment
}
